import { IScheduleState } from "./types";

const initialState: IScheduleState = {
  errors: [],
  isCreatingEvent: false,
  isTransferring: false,
  isDeletingEvent: false,
  isFetchingEvent: false,
  isUpdatingEvent: false,
  events: [],
  lastFetched: null,
  selectedFieldUsers: null,
  eventsCount: 0,
};

export default initialState;
